export default __webpack_public_path__ + "static/media/addon.51c8dc0b.svg";